import "core-js/modules/es.error.to-string.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.search.js";
import { trackCxFoundationsContinueWithoutSignInClick } from "@faire/web-api/events/cxFoundations/click/continueWithoutSignIn";
import { trackCxFoundationsSignInClick } from "@faire/web-api/events/cxFoundations/click/signIn";
import { trackCxFoundationsSignInModalCloseClick } from "@faire/web-api/events/cxFoundations/click/signInModalClose";
import privacy from "@faire/web-api/routes/privacy";
import homepage from "@faire/web-api/routes/root";
import { route as supportHomeRoute } from "@faire/web-api/routes/support";
import { route as supportSelfServeTopicsRoute } from "@faire/web-api/routes/support/self-serve/topics";
import { getCurrentPath } from "@faire/web/common/Path";
import { Button } from "@faire/web/slate/Button";
import { Lock } from "@faire/web/slate/icons/foundation/Lock";
import { Column, Row } from "@faire/web/slate/Layout";
import { Modal } from "@faire/web/slate/Modal";
import { Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import omit from "lodash/omit";
import qs from "query-string";
import * as React from "react";
import { useHistory, useLocation } from "react-router-dom";
export var LoginModal = function LoginModal() {
  var history = useHistory();
  var location = useLocation();
  var locationSearch = function locationSearch() {
    var _location$search;
    return qs.parse((_location$search = location === null || location === void 0 ? void 0 : location.search) !== null && _location$search !== void 0 ? _location$search : "");
  };
  var shouldGoBackToHome = function shouldGoBackToHome() {
    return !!locationSearch().signIn;
  };
  var redirectToPath = function redirectToPath() {
    if (shouldGoBackToHome()) {
      return supportHomeRoute;
    }
    return supportSelfServeTopicsRoute;
  };
  var closeLoginModal = function closeLoginModal() {
    removeContactQueryParam(history);
    trackCxFoundationsSignInModalCloseClick();
  };
  return /*#__PURE__*/React.createElement(Modal, {
    onClose: closeLoginModal,
    justify: "center",
    height: "auto",
    width: "400px",
    padding: "64px 24px 24px",
    shouldCloseOnOverlayClick: false
  }, /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "pageHeaderSerifRegular"
  }, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "ExhzUv",
    defaultMessage: [{
      "type": 0,
      "value": "Connectez-vous pour nous contacter"
    }]
  })), /*#__PURE__*/React.createElement(Spacer, {
    height: "4x"
  }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "rZAwKX",
    defaultMessage: [{
      "type": 0,
      "value": "Connectez votre compte afin que nous puissions mieux vous aider à trouver ce que vous cherchez."
    }]
  })), /*#__PURE__*/React.createElement(Spacer, {
    height: "4x"
  }), /*#__PURE__*/React.createElement(Button, {
    linkTo: homepage({
      signIn: "1",
      redirectTo: redirectToPath()
    }),
    onClick: trackCxFoundationsSignInClick,
    "data-test-id": "login-modal-sign-in-button"
  }, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "P00WcE",
    defaultMessage: [{
      "type": 0,
      "value": "Se connecter"
    }]
  })), /*#__PURE__*/React.createElement(Spacer, {
    height: "2x"
  }), /*#__PURE__*/React.createElement(Button, {
    variant: "tertiary",
    linkTo: getCurrentPath().append({
      loggedOut: "true"
    }).toString(),
    onClick: trackCxFoundationsContinueWithoutSignInClick,
    "data-test-id": "continue-without-signing-in-button"
  }, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "gaPRim",
    defaultMessage: [{
      "type": 0,
      "value": "Continuer sans se connecter"
    }]
  })), /*#__PURE__*/React.createElement(Spacer, {
    height: "2x"
  }), /*#__PURE__*/React.createElement(Row, {
    align: "center"
  }, /*#__PURE__*/React.createElement(Lock, {
    fontSize: "16",
    lockType: "roundedSquare"
  }), /*#__PURE__*/React.createElement(Spacer, {
    size: "1x"
  }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "etV+Ga",
    defaultMessage: [{
      "type": 0,
      "value": "En savoir plus sur la manière dont nous utilisons et protégeons vos données chez Faire. "
    }, {
      "children": [{
        "type": 0,
        "value": "La confidentialité chez Faire"
      }],
      "type": 8,
      "value": "LinkFormatting"
    }],
    values: {
      LinkFormatting: LinkToPrivacy
    }
  })))));
};
var LinkToPrivacy = function LinkToPrivacy(chunks) {
  return /*#__PURE__*/React.createElement(Button, {
    variant: "tertiary",
    linkTo: privacy()
  }, chunks);
};
var removeContactQueryParam = function removeContactQueryParam(history) {
  var _history$location$sea;
  var pathname = history.location.pathname;
  var search = (_history$location$sea = history.location.search) !== null && _history$location$sea !== void 0 ? _history$location$sea : "";
  var query = qs.parse(search);
  history.push("".concat(pathname, "?").concat(qs.stringify(omit(query, ["contact"]))));
};